<p-confirmDialog key="panicalerttopicpersonconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="panicalerttopicperson" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAssign()">Assign Staff</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onUnassign()">Unassign Staff</button>

		<img class="info-img" (click)="onShowInfo()" src="assets/images/info-24.png" />

		<label class="TitleLabel"
			>Assigned Staff - <span class="InfoText">{{ TopicCD }}</span></label
		>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="ShowInfo == true ? 'block' : 'none'">
		<label>Overview:</label><br />
		<label
			>&#9900; This table shows all of the staff members assigned to the topic <span class="InfoText">{{ TopicCD }}</span></label
		><br />
		<label>&#9900; These staff members will recieve a notification in the Staff Portal App when a Panic Alert is sent to their topic</label><br />
		<br />
		<label>&#9900; Assign Staff: Opens a popup to select staff members to add to the topic</label><br />
		<label>&#9900; Unassign Staff: Remove the selected staff members from the topic</label><br />
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPortalPanicAlertTopicPerson"
		[loading]="TableLoading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedPortalPanicAlertTopicPersons"
		dataKey="PortalPanicAlertTopicPersonID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StaffID-->
				<th>
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StaffTitle-->
				<th>
					<p-columnFilter type="text" field="StaffTitle" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Username-->
				<th>
					<p-columnFilter type="text" field="Username" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="StaffTitle">Title<p-sortIcon field="StaffTitle"></p-sortIcon></th>
				<th pSortableColumn="Username">Username<p-sortIcon field="Username"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-PortalPanicAlertTopicPerson>
			<tr [pSelectableRow]="PortalPanicAlertTopicPerson" (dblclick)="onRowDblClick(PortalPanicAlertTopicPerson)">
				<td>
					<p-tableCheckbox
						[disabled]="IsLoading() == true"
						[pSelectableRow]="PortalPanicAlertTopicPerson"
						[value]="PortalPanicAlertTopicPerson"
					></p-tableCheckbox>
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopicPerson.StaffID }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopicPerson.FirstName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopicPerson.LastName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopicPerson.StaffTitle }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ PortalPanicAlertTopicPerson.Username }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
